// This function formats a timestamp in the format of "3:07 PM Sep 4, 2025"
// If this format is changed make sure to update the parsing in DeviceImageListItemBarTitle.tsx
export function formatTimestamp(inputTimestamp: string): string {
  if (!inputTimestamp) {
    return "";
  }

  const date = new Date(inputTimestamp);

  const timeFormatter = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  const dateFormatter = new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });

  const time = timeFormatter.format(date);
  const day = dateFormatter.format(date);

  return `${time} ${day}`;
}

export function convertDateToUTC(localDate: Date | null) {
  if (!localDate) {
    return null;
  }

  // Get the local timezone offset in minutes.
  const offsetMinutes = localDate.getTimezoneOffset();

  // Convert local date to UTC by adding the offset
  // For GMT+3, offsetMinutes = -180, so we substract 180 minutes to the local date.
  // For GMT-8, offsetMinutes = 480, so we add 480 minutes to the local date.
  const utcTimestamp = new Date(localDate.getTime() + offsetMinutes * 60000);

  return utcTimestamp;
}
